import { formatMoney } from '@shopify/theme-currency'

export const centsToPrice = (cents) => {
  if (cents === null || cents === undefined) {
    return  ''
  } else {
    let moneyString = formatMoney(cents, CURRENCY.money_format ?? '${{amount}}')

    if (moneyString.endsWith('.00')) {
      moneyString = moneyString.slice(0, -3)
    }

    return moneyString
  }
}
